import { Checkbox, Icon, Table, Tooltip } from '@mairistem/composants';
import dayjs from 'dayjs';
import _ from 'lodash';
import React from 'react';

import type { FactureType } from '@/types';
import { formatMonetaire, utils_string } from '@/utils';

interface ModalEncaissementTableBodyRowProps {
  nombreFactures: number;
  facture: FactureType;
  selected: number[];
  produitsMontants: boolean;
  onSelect: (checked: boolean, identifiant: number) => void;
  /** Télécharge le PDF de la facture à partir de l'identifiant de son document */
  onOpenPdf: (identifiantDocument: number) => void;
}

const ModalEncaissementTableBodyRow = (props: ModalEncaissementTableBodyRowProps) => {
  const { nombreFactures, facture, selected, produitsMontants, onSelect, onOpenPdf } = props;

  const { payeur, cycle, numero, lignes, identifiantDocument } = facture;
  const { nom, prenom, civilite } = payeur || {};
  const { abreviation } = civilite || {};

  const montantTotal = React.useMemo(() => _.sumBy(lignes, 'montant'), [lignes]);
  const restePayer = React.useMemo(() => _.sumBy(lignes, 'reste'), [lignes]);

  const isSelected = React.useMemo(
    () => _.includes(selected, facture.identifiant),
    [selected, facture.identifiant],
  );

  return (
    <Table.Row
      {...(isSelected && { className: 'selected' })}
      // active={isSelected}
      // positive={isSelected}
      // warning={isSelected}
    >
      {nombreFactures > 1 && (
        <Table.Cell textAlign="center">
          <Checkbox
            data-testid="checkbox-select"
            checked={_.includes(selected, facture.identifiant)}
            onChange={(e, data) => onSelect(data.checked, facture.identifiant)}
          />
        </Table.Cell>
      )}
      <Table.Cell style={{ width: 175 }}>
        <div style={{ display: 'flex' }}>
          <div className="textEllipsis" style={{ flex: 1 }} title={numero}>
            {numero}
          </div>
          {!_.isNil(identifiantDocument) && (
            <Tooltip
              mouseEnterDelay={100}
              // @ts-expect-error
              flowing
              position="bottom center"
              trigger={
                <Icon
                  data-testid="button-pdf"
                  name="file pdf"
                  fitted
                  onClick={() => onOpenPdf(identifiantDocument)}
                  link
                  size="large"
                />
              }
              message={<>Accéder à la facture PDF</>}
            />
          )}
        </div>
      </Table.Cell>
      <Table.Cell>
        {`${abreviation || ''} ${utils_string.toOfficialLastname(nom || '')} ${utils_string.toOfficialFirstname(prenom || '')}`}
      </Table.Cell>
      <Table.Cell>
        {cycle.titre}
        {' - '}
        {dayjs(cycle.dateEmission).format('DD/MM/YYYY')}
      </Table.Cell>
      <Table.Cell textAlign="center">{dayjs(cycle.dateLimite).format('DD/MM/YYYY')}</Table.Cell>
      {produitsMontants && (
        <Table.Cell style={{ padding: 0 }}>
          <Table style={{ border: 'none' }}>
            <Table.Body>
              {_.map(lignes, (ligne) => (
                <Table.Row {...(isSelected && { className: 'selected' })}>
                  <Table.Cell>{ligne?.produit?.libelle}</Table.Cell>
                  <Table.Cell
                    style={{
                      width: 90,
                    }}
                    textAlign="right"
                  >
                    {formatMonetaire(ligne.montant)}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Table.Cell>
      )}
      <Table.Cell textAlign="right">{formatMonetaire(montantTotal)}</Table.Cell>
      <Table.Cell textAlign="right">
        {isSelected ? <b>{formatMonetaire(restePayer)}</b> : formatMonetaire(restePayer)}
      </Table.Cell>
      <Table.Cell style={{ borderLeft: 0 }} />
    </Table.Row>
  );
};

export default ModalEncaissementTableBodyRow;
